module.exports = __webpack_public_path__ + "static/media/open-in-new-tab.362c839e.svg";